// Tracks scroll position & speed delta
export class Scroll {
  static currentPosition: number = 0
  static lastRequestTime: number
  static delta = 0
  private static eventListener

  static init() {
    Scroll.currentPosition = window.pageYOffset
    Scroll.delta = 0
    Scroll.lastRequestTime = performance.now()
    Scroll.eventListener = setInterval(Scroll.calcDelta.bind(Scroll), 100)
  }

  private static calcDelta(): void {
    requestAnimationFrame(() => {
      Scroll.calcDeltaHelper()
    })
  }

  private static calcDeltaHelper() {
    const currentTime = performance.now()
    const timeDelta = currentTime - Scroll.lastRequestTime

    // poor man's throttle.  Sometimes, when the browser is being taxed, several
    // requestAnimationFrames get stacked up and run in sequence i.e. <1ms apart.
    // If that happens, this will skip the calculation of the scrollDelta
    // eslint-disable-next-line no-magic-numbers
    if (timeDelta < 25) {
      return
    }

    const pageYOffset = window.pageYOffset

    Scroll.delta = Math.abs(
      (Scroll.currentPosition - pageYOffset) / (timeDelta / 100)
    )

    Scroll.currentPosition = pageYOffset
    Scroll.lastRequestTime = currentTime
  }
}
